import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogTundishShroud } from "../../../models/CatalogTundishShroud";
import { useCatalogTundishShroudContext } from "../context/CatalogTundishShroudContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setTundishShroud: (tS: CatalogTundishShroud) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setTundishShroud,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogTundishShroudContext();

  const rows: CatalogTundishShroud[] =
    state.tundishShrouds?.map((tundish: CatalogTundishShroud) => ({
      ...tundish,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "TundishShroudName",
      headerName: "Name",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setTundishShroud,
        data: params.data as CatalogTundishShroud,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "tundishShroudContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
